import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=5fd69bb7&scoped=true"
import script from "./DoctorList.vue?vue&type=script&lang=js"
export * from "./DoctorList.vue?vue&type=script&lang=js"
import style0 from "./DoctorList.vue?vue&type=style&index=0&id=5fd69bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd69bb7",
  null
  
)

export default component.exports